import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { techPartnersPartnerBenefits } from "@/mocks/techPartnersData";

export default function TechPartnersEngagement() {
  return (
    <section className="bg-tie-navy py-16 md:py-24 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/20 mb-4 md:mb-6">
                <span className="text-xs font-semibold text-tie-teal-light uppercase tracking-wider">
                  / Partner Benefits
                </span>
              </div>
              <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight">
                {techPartnersPartnerBenefits.title}
              </h2>
              <p className="mt-3 md:mt-4 text-base text-white/60">
                {techPartnersPartnerBenefits.description}
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {techPartnersPartnerBenefits.items.map((item, index) => (
              <ScrollReveal key={item.title} delay={index * 100}>
                <div className="group h-full p-5 md:p-6 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-tie-teal/30 transition-all duration-300">
                  <div className="w-12 h-12 rounded-lg bg-tie-teal/20 flex items-center justify-center mb-4 group-hover:bg-tie-teal/30 transition-colors">
                    <i className={`${item.icon} text-tie-teal-light text-xl`} />
                  </div>
                  <h3 className="text-base md:text-lg font-semibold text-white mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-white/60 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}